<template>
  <div class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import store from '@/plugins/vuex';

export default defineComponent({
  name: 'Migrate',
  mounted() {
    store.commit.target.setType('aison-record');
  },
});
</script>
<style scoped>
.wrapper {
  margin-left: 54px;
  padding-top: 56px;
}
</style>
